//線が伸びるための設定を関数でまとめる
function ScrollTimelineAnime(){
  var elemPos = $('.history-contents__inner').offset().top;// 上からの高さ取得
  var scroll = $(window).scrollTop();// スクロール値取得
  var windowHeight = $(window).height();// windowの高さ取得
  var startPoint = 100;

  if (scroll >= elemPos - windowHeight - startPoint){  
    var H = $('.history-contents__inner').outerHeight(true);
    //liの余白と高さを含めた数値を取得
    //スクロール値から要素までの高さを引いた値を、liの高さの半分のパーセントで出す
    var percent = (scroll+startPoint - elemPos) / (H/2) *100;//liの余白と高さの半分で線を100％に伸ばす

    // 100% を超えたらずっと100%を入れ続ける
    if(percent  > 100){
      percent  = 100;
    }
    // ボーダーの長さをセット
    $('.border-line').css({
      height: percent + "%", //CSSでパーセント指定
    });
  } 
}



function fadeAnime(){
  $('.fadeLeftTrigger').each(function(){ //fadeLeftTriggerというクラス名が
    var elemPos = $(this).offset().top+200;//要素より、50px上の
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll >= elemPos - windowHeight){
      $(this).addClass('fadeLeft');// 画面内に入ったらfadeLeftというクラス名を追記
    }
    // else{
    //   $(this).removeClass('fadeLeft');// 画面外に出たらfadeLeftというクラス名を外す
    // }
  });

  $('.fadeRightTrigger').each(function(){ //fadeRightTriggerというクラス名が
    var elemPos = $(this).offset().top+200;//要素より、50px上の
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll >= elemPos - windowHeight){
      $(this).addClass('fadeRight');// 画面内に入ったらfadeRightというクラス名を追記
    }
    // else{
    //   $(this).removeClass('fadeRight');// 画面外に出たらfadeRightというクラス名を外す
    // }
  });
}



// 画面をスクロールをしたら動かしたい場合の記述
$(window).on('scroll', function(){
  if($("#history").length) {
    ScrollTimelineAnime();// 線が伸びる関数を呼ぶ
    fadeAnime();/* アニメーション用の関数を呼ぶ*/
  }
});





